// extracted by mini-css-extract-plugin
module.exports = {"menu":"Nav_menu__CQTb4","menuItem":"Nav_menuItem__1CZyY","navItem":"Nav_navItem__1_4Zu","user":"Nav_user__2dy2P","logout":"Nav_logout__2KlZw"};